module.exports = __webpack_public_path__ + "static/media/girl-with-speakers.8782aecb.svg";